module.exports = __webpack_public_path__ + "img/title-4.f00eccb8.png";